import { render, staticRenderFns } from "./Tkcx.vue?vue&type=template&id=4346192a&scoped=true"
import script from "./Tkcx.vue?vue&type=script&lang=js"
export * from "./Tkcx.vue?vue&type=script&lang=js"
import style0 from "./Tkcx.vue?vue&type=style&index=0&id=4346192a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4346192a",
  null
  
)

export default component.exports